/*
 * product-gallery.js — sticky image carousel for sections/main-product.liquid.
 * Vanilla, no dependency. Arrows + wrap-around, keyboard (Left/Right), pointer
 * swipe, live counter. Cross-fade timing lives in the section's own CSS and is
 * already neutralised there under prefers-reduced-motion, so there's nothing
 * motion-related to gate here.
 */
(function () {
  function initGallery(root) {
    var slides = root.querySelectorAll('.pp__slide');
    if (slides.length < 2) return; // single image: nothing to wire up

    var prev = root.querySelector('.pp__arrow--prev');
    var next = root.querySelector('.pp__arrow--next');
    var counter = root.querySelector('[data-gallery-counter]');
    var i = 0; // slide 0 is already the active one server-rendered

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (slide, idx) {
        var active = idx === i;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }

    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
    });

    var startX = 0, startY = 0, tracking = false;
    root.addEventListener('pointerdown', function (e) {
      startX = e.clientX; startY = e.clientY; tracking = true;
    });
    root.addEventListener('pointerup', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
})();
